import(/* webpackMode: "eager" */ "/tmp/8def864e41e4ec0/app/[locale]/error.tsx");
